var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.1,18.7 7.1,16 10.5,16 10.5,8.6 7.1,10.9 7.1,7.7 10.8,5.3 13.7,5.3 13.7,16 16.9,16 16.9,18.7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteger);
export default __webpack_public_path__ + "static/media/integer.3787766649923d438542160abf5a61bd.svg";
export { ForwardRef as ReactComponent };